import React from 'react';
import { useSelector } from 'react-redux';
import { Helmet } from '@okapi/helmet-react';
import { selectPageModelSE0 } from '../../../../../store/pageModel/selectors';

export const MetaSEO = () => {
	const pageModelSEO = useSelector(selectPageModelSE0);
	const title = pageModelSEO?.pageTitle || '';
	const description = pageModelSEO?.metadescription || '';
	const keywords = pageModelSEO?.metakeywords || '';
	const canonical = pageModelSEO?.canonicalURL || '';

	return (
		<Helmet>
			<title>{title}</title>
			<meta name="description" content={description} />
			<meta name="keywords" content={keywords} />
			<link rel="canonical" href={canonical} />
		</Helmet>
	);
};
